module.exports = __webpack_public_path__ + "media/fonts/gotham-light-webfont-25f835897ddf1d072cdf92b522eeead5.woff2";